export const STICKY_HEADER_HEIGHT_DESKTOP = 65;
export const STICKY_HEADER_HEIGHT_MOBILE = 60;
